import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AgCharts } from "ag-charts-react";
import { article_details } from "../api";
import LoadingScreen from "react-loading-screen";
import html2canvas from "html2canvas";
import Modal from "./Modal";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";

const Dynamicgraph = ({ id }) => {
  const [data, setData] = useState([]);
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const pdfRef = useRef();
  const [modalOpen, setModalOpen] = useState({});
  const [excelData, setExcelData] = useState([]);
  const [fileStatus, setFileStatus] = useState("");

  useEffect(() => {
    fetchreport();
  }, [id]);

  useEffect(() => {
    if (data) {
      let exceldata = data.map((item, i) => ({
        CheckNo: item.check,
        CheckTitle: item.check_title,
        Count: item.count,
      }));

      setExcelData(exceldata);
    }
  }, [data]);

  console.log(data);

  useEffect(() => {
    window.data = data;
  }, [data]);

  let fetchreport = async () => {
    const TIMEOUT = 50000; // 50 seconds
    const timeoutPromise = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Timeout")), TIMEOUT)
    );

    try {
      const result = await Promise.race([article_details(id), timeoutPromise]);
      if (result.data) {
        setFileStatus(result?.data?.file_progress);
        setLoading(false);
        setData(result?.data?.report);
        setCategory(result?.data?.category);
      } else {
        toast.warn(result.error.message);
        navigate("/filehistory");
      }
    } catch (e) {
      if (e.message === "Timeout") {
        toast.warn("Response took longer than expected, Redirecting ...");
        navigate("/filehistory"); // Replace with your timeout page route
      } else {
        console.log(e?.response?.data?.message || e.message);
      }
    }
  };

  console.log(fileStatus);
  // console.log(category);

  const sortedReport =
    data &&
    data.length > 0 &&
    data.reduce((group, item) => {
      if (!group[item.category_id]) {
        group[item.category_id] = [];
      }
      group[item.category_id].push(item);
      return group;
    }, {});

  //   console.log(sortedReport);

  const MailComponent = () => {
    return <p>"No value"</p>;
  };

  const CountData = ({ data }) => {
    return (
      <div className=" flex flex-col-reverse min-h-[130px] min-w-[200px] text-left gap-1 border-[1px] p-3 h-fit overflow-hidden rounded-[24px]">
        <div
          className={`${
            data?.content?.[0]?.count?.length > 5 ? "text-16" : "text-24"
          } font-semibold m-auto`}
        >
          {Array.isArray(data?.content) &&
          data?.content?.length > 0 &&
          data.content?.[0]?.count ? (
            data.content?.[0]?.count === 0 ? (
              "N/A"
            ) : (
              data.content?.[0]?.count
            )
          ) : data?.count !== undefined ? (
            data.count === 0 ? (
              "N/A"
            ) : (
              data.count
            )
          ) : (
            <MailComponent />
          )}
        </div>
        <hr className="border-[1px] border-[#FEB13F]"></hr>
        <p className="mx-auto text-14">{data.check_title}</p>
      </div>
    );
  };

  const TrueFalseData = ({ data }) => {
    return (
      <div className=" flex flex-col-reverse min-h-[130px] min-w-[200px] text-left gap-1 border-[1px] p-3 h-fit overflow-hidden rounded-[24px]">
        <div className="m-auto font-semibold">
          {Array.isArray(data?.content) &&
          data?.content?.[0] &&
          data?.content?.[0]?.ifexists !== undefined ? (
            <span
              className={`text-24 ${
                data?.content?.[0]?.ifexists?.toString().toLowerCase() ===
                "true"
                  ? "text-[green]"
                  : "text-[red]"
              }`}
            >
              {data?.content?.[0]?.ifexists
                ?.toString()
                .charAt(0)
                .toUpperCase() +
                data?.content?.[0]?.ifexists?.toString().slice(1)}
            </span>
          ) : data?.ifexits ? (
            <span
              className={`text-24 ${
                data.ifexits.toLowerCase() === "true"
                  ? "text-[green]"
                  : "text-[red]"
              }`}
            >
              {data.ifexits.toString().charAt(0).toUpperCase() +
                data.ifexits.toString().slice(1)}
            </span>
          ) : (
            <MailComponent />
          )}
        </div>
        <hr className="border-[1px] border-[#FEB13F]"></hr>
        <p className="mx-auto text-14">{data.check_title}</p>
      </div>
    );
  };

  const PopUpData = ({ data, title, indexing, children, check, type }) => {
    return (
      <div className=" flex flex-col-reverse min-h-[130px] min-w-[200px] text-left gap-1 border-[1px] p-3 h-fit overflow-hidden rounded-[24px]">
        {type === "truefalse" ? (
          <div className="m-auto font-semibold">
            {Array.isArray(data?.content) &&
            data?.content?.[0] &&
            data?.content?.[0]?.ifexists !== undefined ? (
              <span
                className={`text-24 ${
                  data?.content?.[0]?.ifexists?.toString().toLowerCase() ===
                  "true"
                    ? "text-[green]"
                    : "text-[red]"
                }`}
              >
                {data?.content?.[0]?.ifexists
                  ?.toString()
                  .charAt(0)
                  .toUpperCase() +
                  data?.content?.[0]?.ifexists?.toString().slice(1)}
              </span>
            ) : data?.ifexits ? (
              <span
                className={`text-24 ${
                  data.ifexits.toLowerCase() === "true"
                    ? "text-[green]"
                    : "text-[red]"
                }`}
              >
                {data.ifexits.toString().charAt(0).toUpperCase() +
                  data.ifexits.toString().slice(1)}
              </span>
            ) : (
              <MailComponent />
            )}
          </div>
        ) : (
          <div
            className={`${
              data?.content?.[0]?.count?.length > 5 ? "text-16" : "text-24"
            } font-semibold m-auto`}
          >
            {Array.isArray(data?.content) &&
            data?.content?.length > 0 &&
            data.content?.[0]?.count ? (
              data.content?.[0]?.count === 0 ? (
                "N/A"
              ) : (
                data.content?.[0]?.count
              )
            ) : data?.count !== undefined ? (
              data.count === 0 ? (
                "N/A"
              ) : (
                data.count
              )
            ) : (
              <MailComponent />
            )}
          </div>
        )}
        <hr className="border-[1px] border-[#FEB13F]"></hr>
        <div className="flex items-center">
          <p className="mx-auto text-14">{data?.check_title}</p>
          <div className="w-fit">
            {data?.content?.[0]?.content?.length > 0 &&
              data?.content?.[0]?.content !== "" && (
                <button
                  onClick={() =>
                    setModalOpen((prev) => ({ ...prev, [check]: true }))
                  }
                  className=" py-1 px-3 rounded-[6px] bg-[#FEB13F]"
                >
                  <p className="">!</p>
                </button>
              )}
          </div>
        </div>
        <Modal show={modalOpen[check]}>
          <div className="flex flex-col gap-3 justify-between w-full items-center pb-3 p-5 max-h-[500px] rounded-[16px]">
            <div className="flex justify-between w-full items-center">
              <h className="text-24 font-semibold">{title}</h>
              <button
                onClick={() =>
                  setModalOpen((prev) => ({ ...prev, [check]: false }))
                }
                className="ml-8 py-1 px-3 rounded-[6px] bg-[#FEB13F]"
              >
                <p className="">X</p>
              </button>
            </div>
            {indexing && (
              <div className="w-full flex flex-col gap-2">
                <div className="flex items-center w-full">
                  <span className="h-4 w-4 rounded-full bg-[red] mr-4"></span>
                  <p>{indexing?.title1}</p>
                </div>
                <div className="flex items-center w-full">
                  <span className="h-4 w-4 rounded-full bg-[green] mr-4"></span>
                  <p>{indexing?.title2}</p>
                </div>
              </div>
            )}
            <hr className="border-[.5px] border-[#C4C6CC] w-full"></hr>
            <div className="h-fit w-full p-5 overflow-y-scroll mt-2">
              {Array.isArray(data?.content) ? (
                <ul className="list-disc space-y-4">
                  {Array.isArray(data?.content?.[0]?.content)
                    ? data?.content?.[0]?.content.map((list, i) => (
                        <li key={i}>{list}</li>
                      ))
                    : data?.content?.map((list, i) => (
                        <li key={i}>{list.content}</li>
                      ))}
                </ul>
              ) : (
                <p>{data?.content || "No content available"}</p>
              )}
            </div>
          </div>
        </Modal>
      </div>
    );
  };

  const TablePopUp = ({ data, type, title, check, indexing }) => {
    const [modalOpen, setModalOpen] = useState({});

    const isArrayContent = Array.isArray(data?.content);
    const hasNestedContent = isArrayContent
      ? data.content.some((item) => typeof item?.content === "object")
      : false;

    const tableHeaders = Array.isArray(data?.content?.[0]?.content)
      ? [
          ...new Set(
            data.content[0].content.flatMap((obj) => Object.keys(obj || {}))
          ),
        ]
      : [];

    return (
      <div className="flex flex-col-reverse min-h-[130px] min-w-[200px] text-left gap-1 border-[1px] p-3 h-fit overflow-hidden rounded-[24px]">
        {type === "truefalse" ? (
          <div className="m-auto font-semibold">
            {Array.isArray(data?.content) &&
            data?.content?.[0] &&
            data?.content?.[0]?.ifexists !== undefined ? (
              <span
                className={`text-24 ${
                  data?.content?.[0]?.ifexists?.toString().toLowerCase() ===
                  "true"
                    ? "text-[green]"
                    : "text-[red]"
                }`}
              >
                {data?.content?.[0]?.ifexists
                  ?.toString()
                  .charAt(0)
                  .toUpperCase() +
                  data?.content?.[0]?.ifexists?.toString().slice(1)}
              </span>
            ) : data?.ifexits ? (
              <span
                className={`text-24 ${
                  data.ifexits.toLowerCase() === "true"
                    ? "text-[green]"
                    : "text-[red]"
                }`}
              >
                {data.ifexits.toString().charAt(0).toUpperCase() +
                  data.ifexits.toString().slice(1)}
              </span>
            ) : (
              <MailComponent />
            )}
          </div>
        ) : (
          <div
            className={`${
              data?.content?.[0]?.count?.length > 5 ? "text-16" : "text-24"
            } font-semibold m-auto`}
          >
            {Array.isArray(data?.content) &&
            data?.content?.length > 0 &&
            data.content?.[0]?.count ? (
              data.content?.[0]?.count === 0 ? (
                "N/A"
              ) : (
                data.content?.[0]?.count
              )
            ) : data?.count !== undefined ? (
              data.count === 0 ? (
                "N/A"
              ) : (
                data.count
              )
            ) : (
              <MailComponent />
            )}
          </div>
        )}

        <hr className="border-[1px] border-[#FEB13F]" />

        <div className="flex items-center">
          <p className="mx-auto text-14">
            {data?.check_title || "Untitled Check"}
          </p>
          <div className="w-fit">
            {data?.content?.[0]?.content && (
              <button
                onClick={() =>
                  setModalOpen((prev) => ({ ...prev, [check]: true }))
                }
                className="py-1 px-3 rounded-[6px] bg-[#FEB13F]"
              >
                !
              </button>
            )}
          </div>
        </div>

        <Modal show={modalOpen?.[check]}>
          <div className="flex flex-col gap-3 w-full p-5 max-h-[500px] rounded-[16px]">
            <div className="flex justify-between w-full items-center">
              <h2 className="text-24 font-semibold">{title}</h2>
              <button
                onClick={() =>
                  setModalOpen((prev) => ({ ...prev, [check]: false }))
                }
                className="ml-8 py-1 px-3 rounded-[6px] bg-[#FEB13F]"
              >
                X
              </button>
            </div>

            <hr className="border-[.5px] border-[#C4C6CC] w-full" />

            <div className="h-fit max-h-[300px] w-full overflow-y-scroll mt-2">
              {hasNestedContent ? (
                <p className="text-center text-red-500 p-4">
                  Nested content detected. Please select a different display
                  type.
                </p>
              ) : (
                <table className="w-full border border-gray-300">
                  {tableHeaders.length > 0 && (
                    <thead>
                      <tr>
                        {tableHeaders.map((key, i) => (
                          <th
                            key={i}
                            className="border border-gray-300 px-2 py-1"
                          >
                            {key}
                          </th>
                        ))}
                      </tr>
                    </thead>
                  )}
                  <tbody>
                    {Array.isArray(data?.content?.[0]?.content) &&
                    data.content[0].content.length > 0 ? (
                      data.content[0].content.map((row, i) => (
                        <tr key={i}>
                          {tableHeaders.map((header, j) => (
                            <td
                              key={j}
                              className="border border-gray-300 px-2 py-1"
                            >
                              {row?.[header] ?? "N/A"}
                            </td>
                          ))}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={tableHeaders.length || 1}
                          className="text-center py-2"
                        >
                          No Data to Display
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </Modal>
      </div>
    );
  };

  // MARK: Chart reporting ----------------------------------------
  const Chart = ({ data }) => {
    const [options, setOptions] = useState({
      title: {
        text: "Checks",
        fontSize: 24,
        fontWeight: 600,
      },
      data: data,
      series: [
        {
          type: "bar",
          direction: "horizontal",
          xKey: "check_title",
          yKey: "count",
          yName: "Checks",
          fill: "#FEB13F",
          label: {
            enabled: true,
            color: "black",
            fontSize: 14,
            placement: "outside",
            formatter: ({ value }) => value.toString(),
          },
        },
      ],
      height: 400,
    });

    return <AgCharts options={options} />;
  };

  const Referencehistogram = ({ data }) => {
    try {
      if (data?.content?.[0].content?.length > 1) {
        data =
          data &&
          data?.content?.[0]?.content?.map((entry) => {
            const key = Object.keys(entry)[0]; // Get the single key in each object
            return { name: key.trim(), value: parseInt(entry[key].trim()) };
          });

        // console.log(data);
      } else {
        data = 0;
      }
    } catch (e) {
      data = 0;
    }
    const [options, setOptions] = useState({
      title: {
        text: "Reference Year Histogram",
        fontSize: 24,
        fontWeight: 600,
      },
      data: data,
      series: [
        {
          type: "bar",
          xKey: "name",
          yKey: "value",
          yName: "Checks",
          fill: "#FEB13F",
          label: {
            enabled: true,
            color: "black",
            fontSize: 14,
            placement: "outside",
            formatter: ({ value }) => value.toString(),
          },
        },
      ],
      height: 400,
    });

    return <AgCharts options={options} />;
  };

  const Tablegraph = ({ data }) => {
    const [options, setOptions] = useState({
      title: { text: Array.isArray(data) ? "Report" : data.check_title },
      legend: { position: "bottom" },
      series: [],
    });

    useEffect(() => {
      if (!data) return;

      // Normalize data to always be an array
      const chartData = Array.isArray(data)
        ? data
        : [{ check_title: data.check_title, count: data.count }];

      if (chartData.length === 0) {
        setOptions((prev) => ({ ...prev, series: [] }));
        return;
      }

      // Donut chart series
      const series = [
        {
          type: "donut",
          angleKey: "count",
          calloutLabelKey: "check_title",
          sectorLabelKey: "count",
          innerRadiusRatio: 0.5,
          data: chartData,
          fills: ["#5e52ea", "#FFB74D", "#FFD54F", "#4CAF50"], // more colors if needed
        },
      ];

      setOptions((prev) => ({
        ...prev,
        title: {
          text: chartData.length === 1 ? chartData[0].check_title : "Report",
        },
        series,
      }));
    }, [data]);

    return <AgCharts options={options} />;
  };

  const NestedTablePopUp = ({ data, title }) => {
    const [modalOpen, setModalOpen] = useState(null);

    // ✅ Early check for empty content
    const isEmptyContent =
      !data?.content ||
      !Array.isArray(data.content) ||
      data.content.length === 0;

    // Collect all top-level keys dynamically
    const allKeys = Array.from(
      new Set(data?.content?.flatMap((item) => Object.keys(item || {})) || [])
    );

    // Filter keys to exclude "content" if it's not present at all
    const hasContentKey = data?.content?.some(
      (item) => "content" in (item || {})
    );
    const displayKeys = hasContentKey
      ? allKeys.filter((key) => key !== "content")
      : allKeys;

    // ✅ Helper: render any value safely
    const renderValue = (val) => {
      if (val == null || val === "NULL") return "N/A";
      if (Array.isArray(val))
        return val.length > 0 ? val.join(", ") : "No relevant data found";
      if (typeof val === "object") return JSON.stringify(val);
      return val.toString();
    };

    // ✅ Detect if content is nested (array of objects or object)
    const isNestedContent = (content) => {
      if (!content) return false;
      if (Array.isArray(content)) {
        return content.some(
          (item) => typeof item === "object" && !Array.isArray(item)
        );
      }
      return typeof content === "object";
    };

    // ✅ Render nested content inside modal
    const renderNestedTable = (nested) => {
      if (!nested || (Array.isArray(nested) && nested.length === 0)) {
        return <p>No relevant data found.</p>;
      }

      // Array of objects
      if (
        Array.isArray(nested) &&
        nested.every((item) => typeof item === "object")
      ) {
        const nestedKeys = Array.from(
          new Set(nested.flatMap((obj) => Object.keys(obj || {})))
        );
        return (
          <table className="w-full border border-gray-300">
            <thead>
              <tr>
                {nestedKeys.map((key) => (
                  <th key={key} className="border px-2 py-1">
                    {key}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {nested.map((obj, idx) => (
                <tr key={idx}>
                  {nestedKeys.map((key) => (
                    <td key={key} className="border px-2 py-1">
                      {renderValue(obj[key])}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        );
      }

      // Array of primitives
      if (Array.isArray(nested)) {
        return nested.length === 0 ? (
          <p>No relevant data found.</p>
        ) : (
          <ul className="list-disc ml-5">
            {nested.map((item, idx) => (
              <li key={idx}>{renderValue(item)}</li>
            ))}
          </ul>
        );
      }

      // Object → single-row table
      if (typeof nested === "object") {
        const keys = Object.keys(nested);
        if (keys.length === 0) return <p>No relevant data found.</p>;
        return (
          <table className="w-full border border-gray-300">
            <thead>
              <tr>
                {keys.map((key) => (
                  <th key={key} className="border px-2 py-1">
                    {key}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                {keys.map((key) => (
                  <td key={key} className="border px-2 py-1">
                    {renderValue(nested[key])}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        );
      }

      // Primitive fallback
      return <p>{renderValue(nested)}</p>;
    };

    return (
      <div className="flex flex-col min-h-[130px] min-w-[200px] text-left gap-1 border-[1px] p-3 h-fit overflow-hidden rounded-[24px] min-h-fit max-h-[250px]">
        <p className="mx-auto text-14">{data?.check_title}</p>
        <hr className="border-[1px] border-[#FEB13F]" />

        <div className="overflow-x-auto">
          <table className="w-full border border-gray-300">
            <thead>
              <tr>
                {displayKeys.map((key) => (
                  <th key={key} className="border border-gray-300 px-2 py-1">
                    {key}
                  </th>
                ))}
                {hasContentKey && (
                  <th className="border border-gray-300 px-2 py-1">Content</th>
                )}
              </tr>
            </thead>

            <tbody>
              {isEmptyContent ? (
                <tr>
                  <td
                    colSpan={displayKeys.length + (hasContentKey ? 1 : 0)}
                    className="text-center py-2"
                  >
                    No relevant data found
                  </td>
                </tr>
              ) : (
                data.content.map((row, rowIndex) => {
                  const nested = row.content;
                  const nestedFlag = isNestedContent(nested);

                  return (
                    <tr key={rowIndex}>
                      {displayKeys.map((key) => (
                        <td
                          key={key}
                          className="border border-gray-300 px-2 py-1"
                        >
                          {renderValue(row[key])}
                        </td>
                      ))}

                      {hasContentKey && (
                        <td className="border border-gray-300 px-2 py-1 text-center">
                          {nestedFlag ? (
                            <button
                              className="px-3 py-1 rounded bg-[#FEB13F] font-bold"
                              onClick={() => setModalOpen(rowIndex)}
                            >
                              !
                            </button>
                          ) : (
                            renderValue(nested)
                          )}
                        </td>
                      )}

                      {modalOpen === rowIndex && nestedFlag && (
                        <Modal show={true}>
                          <div className="flex flex-col gap-3 justify-between w-full items-center pb-3 p-5 max-h-[500px] rounded-[16px]">
                            <div className="flex justify-between w-full items-center">
                              <h className="text-24 font-semibold">
                                {title} - Row {rowIndex + 1}
                              </h>
                              <button
                                onClick={() => setModalOpen(null)}
                                className="ml-8 py-1 px-3 rounded-[6px] bg-[#FEB13F]"
                              >
                                X
                              </button>
                            </div>

                            <hr className="border-[.5px] border-[#C4C6CC] w-full" />

                            <div className="h-fit max-h-[300px] w-full overflow-y-scroll mt-2">
                              {renderNestedTable(nested)}
                            </div>
                          </div>
                        </Modal>
                      )}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const reportdata = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(reportdata, "report.xlsx");
  };

  const generatePDF = () => {
    const input = pdfRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4"); // portrait, mm units, A4 size
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      // Convert canvas dimensions to mm
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      // Add first page
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;

      // Add more pages if needed
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      pdf.save("report.pdf");
    });
  };

  return (
    <LoadingScreen
      loading={loading}
      bgColor="#f1f1f1"
      spinnerColor="#9ee5f8"
      textColor="#676767"
      // logoSrc="/logo.png"
      text="Fetching Data please wait"
    >
      <div className="w-full h-full flex flex-col gap-5">
        {data?.length > 0 ? (
          <>
            <div className="w-full p-10 flex justify-between">
              <h2 className="text-24 text-154A79 font-semibold">
                Article Report
              </h2>
              <div className="flex gap-3">
                <button
                  className="text-[#333] hover:text-[#FEB13F]"
                  type="button"
                  onClick={() => exportToExcel()}
                >
                  Generate Excel
                </button>
                <button
                  className="text-[#333] hover:text-[#FEB13F]"
                  type="button"
                  onClick={() => generatePDF()}
                >
                  Generate PDF
                </button>
              </div>
            </div>
            <div ref={pdfRef} className="flex flex-col gap-10 px-10">
              {category.map((cat, i) => {
                const reports = sortedReport[cat.category] || [];

                const charts = reports.filter(
                  (rep) => rep?.display_type?.trim().toLowerCase() === "chart"
                );

                const counts = reports.filter(
                  (rep) => rep?.display_type?.trim().toLowerCase() === "count"
                );

                const truefalse = reports.filter(
                  (rep) =>
                    rep?.display_type?.trim().toLowerCase() === "true_false"
                );

                const truefalselist = reports.filter(
                  (rep) =>
                    rep?.display_type?.trim().toLowerCase() ===
                    "true_false_list"
                );

                const truefalsetable = reports.filter(
                  (rep) =>
                    rep?.display_type?.trim().toLowerCase() ===
                    "true_false_table"
                );

                const countlist = reports.filter(
                  (rep) =>
                    rep?.display_type?.trim().toLowerCase() === "count_list"
                );

                const counttable = reports.filter(
                  (rep) =>
                    rep?.display_type?.trim().toLowerCase() === "count_table"
                );

                const histogram = reports.filter(
                  (rep) =>
                    rep?.display_type?.trim().toLowerCase() === "histogram"
                );

                const donut = reports.filter(
                  (rep) =>
                    rep?.display_type?.trim().toLowerCase() === "donut_chart"
                );

                const tablewithpopup = reports.filter(
                  (rep) =>
                    rep?.display_type?.trim().toLowerCase() === "table_popup"
                );

                return (
                  <div key={i}>
                    {reports.length > 0 && (
                      <div className="flex flex-col gap-2">
                        <div className="flex text-left text-24">
                          <h1>{cat.value}</h1>
                        </div>
                        <div className="flex flex-col gap-4">
                          <div className="grid grid-cols-1 md:grid-cols-2 w-[full] gap-5">
                            {charts.length > 0 && (
                              <div className="w-full border border-gray ">
                                <Chart data={charts} />
                              </div>
                            )}
                            {histogram.length > 0 && (
                              <div className="w-full border border-gray ">
                                {histogram.map((histo) => (
                                  <Referencehistogram data={histo} />
                                ))}
                              </div>
                            )}
                            {donut.length > 0 && (
                              <div className="w-full border border-gray ">
                                <Tablegraph data={donut} />
                              </div>
                            )}
                          </div>
                          <div className="grid grid-cols-4 gap-3 mt-5">
                            {/* Counts */}
                            {counts.length > 0 &&
                              counts.map((rep, idx) => (
                                <CountData key={`count-${idx}`} data={rep} />
                              ))}

                            {/* Count List */}
                            {countlist.length > 0 &&
                              countlist.map((rep, idx) => (
                                <PopUpData
                                  key={`countlist-${idx}`}
                                  data={rep}
                                  title={rep.check_title}
                                  check={rep.check}
                                  type="count"
                                  indexing={rep?.content?.[0]?.index}
                                />
                              ))}

                            {/* Count Table */}
                            {counttable.length > 0 &&
                              counttable.map((rep, idx) => (
                                <TablePopUp
                                  key={`counttable-${idx}`}
                                  data={rep}
                                  title={rep.check_title}
                                  check={rep.check}
                                  type="count"
                                />
                              ))}

                            {/* True / False List */}
                            {truefalselist.length > 0 &&
                              truefalselist.map((rep, idx) => (
                                <PopUpData
                                  key={`truefalselist-${idx}`}
                                  data={rep}
                                  title={rep.check_title}
                                  check={rep.check}
                                  type="truefalse"
                                  indexing={rep?.content?.[0]?.index}
                                />
                              ))}

                            {/* True / False Table */}
                            {truefalsetable.length > 0 &&
                              truefalsetable.map((rep, idx) => (
                                <TablePopUp
                                  key={`truefalsetable-${idx}`}
                                  data={rep}
                                  title={rep.check_title}
                                  check={rep.check}
                                  type="truefalse"
                                  content={rep?.content?.[0]?.content}
                                />
                              ))}

                            {/* True/False Data */}
                            {truefalse.length > 0 &&
                              truefalse.map((rep, idx) => (
                                <TrueFalseData
                                  key={`truefalse-${idx}`}
                                  data={rep}
                                />
                              ))}
                          </div>
                          <div className="grid grid-cols-3 gap-4">
                            {tablewithpopup.length > 0 &&
                              tablewithpopup.map((rep, idx) => (
                                <NestedTablePopUp
                                  data={rep}
                                  title={rep.check_title}
                                />
                              ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <div className="w-full h-[70vh] flex items-center justify-center">
            <p>
              {fileStatus === "1"
                ? "Report generation yet to start"
                : fileStatus === "2"
                ? "Report generation in progress"
                : "Error with report generation"}
            </p>
          </div>
        )}
      </div>
    </LoadingScreen>
  );
};

export default Dynamicgraph;
